import React, {Component} from 'react' 
import {  Route, Switch, Redirect, withRouter} from 'react-router-dom'
import Personal from './Steps/Personal';
import Education from './Steps/Education';
import Documentation from './Steps/Documentation';
import Crietaria from './Sections/Crietaria';
import { connect } from 'react-redux';
import { toLower } from 'lodash';
class Eligibility extends Component{
     state={
         contary: ''
     }
     componentDidMount(){
         this.setState({
             contary:this.props.match.params.contary
         })
     }
     render(){
        let contary = this.props.contries.find(contary => toLower(contary.name) === this.props.match.params.contary); 
        return(
            <div>
            <div className="banner-image1" style={{backgroundImage: contary?  `url(${ contary.image })` : '' }}> 
              <div className="mx-width">
                  <div className="banner-text">
                       <h1 className="bg-text1 mb-1">Country:</h1>
                       <h1 className="bg-text1 mb-1">{contary?  contary.name : ''}</h1>
                  </div>
              </div>                    
            </div>
            <section>
              <div className="contactus-form py-5">
                  <div className="mx-width">   
                     <div className="row">             
                          <div className="col-lg-8">
                              <section className="form-section">
                                  <div className="form-content"> 
                                    <Switch>
                                            <Route  path="/eligibility/:contary/step1">
                                                <Personal />
                                            </Route>
                                            <Route  path="/eligibility/:contary/step2">
                                                <Education /> 
                                            </Route>
                                            <Route  path="/eligibility/:contary/step3">
                                                <Documentation />
                                            </Route>       
                                    </Switch>    
                                  </div>
                              </section>
                          </div>
                          <Crietaria contries ={this.props.contries} contary={this.props.match.params.contary}/>
                      </div>
                  </div>
              </div>
          </section>            
      
          </div>
        )
     }
}
const mapStateToProps = state => {
    return {
        contries: state.contries
    };
};

 
export default connect(mapStateToProps)(withRouter(Eligibility));